export const isFieldCopy = field => Boolean(field && (field.sourceFieldId != null || field.configurationReadOnly));

export const fieldCopyLabel = field => `Campo copia del campo #${field.sourceFieldId} — configurazione in sola lettura`;
